import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
const BRANDS = [{
  name: 'Mazmak',
  logo: 'https://cdn.magicpatterns.com/uploads/ekScdwAR1UFZGZEeTRAqUS/Untitled_design_13-removebg-preview.png'
}, {
  name: 'DXLR',
  logo: 'https://cdn.magicpatterns.com/uploads/vx7YvgUw4gBVZJxBEyx7g7/Social_sharing-removebg-preview.png'
}, {
  name: 'Dr. Al Sabhan Legal Group',
  logo: 'https://cdn.magicpatterns.com/uploads/fLJkPUDWmebacYweWhFKeG/asa-removebg-preview.png'
}, {
  name: 'Biladi',
  logo: 'https://cdn.magicpatterns.com/uploads/6fACEp18WNvmFT8GTgsuHX/logo2-removebg-preview.png'
}, {
  name: 'MKCA',
  logo: 'https://cdn.magicpatterns.com/uploads/rtNTvSBWxU8YQfiRW3VThg/MKCA_Transperant-01__2___1_-removebg-preview.png'
}, {
  name: 'META Accounting Services',
  logo: 'https://cdn.magicpatterns.com/uploads/1vYovvwdYJUvMFe2KFmjYJ/LOGO-2-768x235__1_-removebg-preview.png'
}, {
  name: 'Tasawer Business Services',
  logo: 'https://cdn.magicpatterns.com/uploads/n7E8Ez9QXBgPugd3rEKRKQ/428709802_803339191823254_280723__1_-removebg-preview.png'
}, {
  name: 'Saisho Restaurant',
  logo: 'https://cdn.magicpatterns.com/uploads/uSdftyTuEJT36GfEtJ9Asv/Logo-Name-Ar-En-White-Transparen.png'
}];
const MARQUEE_ITEMS = [...BRANDS, ...BRANDS];
const itemWidth = 180;
const gap = 48;
const halfWidth = MARQUEE_ITEMS.length / 2 * (itemWidth + gap);
export function BrandsMarquee() {
  const {
    t
  } = useLanguage();
  return <section className="py-14 bg-white border-y border-gray-100 overflow-hidden relative" data-id="element-643">
      <style data-id="element-644">{`
        @keyframes marquee-scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-${halfWidth}px); }
        }
        .marquee-inner {
          display: flex;
          align-items: center;
          gap: ${gap}px;
          width: max-content;
          animation: marquee-scroll 35s linear infinite;
          will-change: transform;
          direction: ltr;
        }
        .marquee-inner:hover {
          animation-play-state: paused;
        }
      `}</style>

      {/* Heading */}
      <div className="max-w-7xl mx-auto px-4 mb-10 text-center" data-id="element-645">
        <h3 className="text-2xl font-bold text-gray-900" data-id="element-646">
          {t('brands.title')}
        </h3>
      </div>

      {/* Marquee */}
      <div className="relative" style={{
      direction: 'ltr'
    }} data-id="element-647">
        {/* Fade left */}
        <div className="absolute left-0 top-0 bottom-0 w-28 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-648" />
        {/* Fade right */}
        <div className="absolute right-0 top-0 bottom-0 w-28 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-649" />

        <div className="overflow-hidden" data-id="element-650">
          <div className="marquee-inner" data-id="element-651">
            {MARQUEE_ITEMS.map((brand, idx) => <div key={`${brand.name}-${idx}`} className="flex-shrink-0 flex items-center justify-center" style={{
            width: `${itemWidth}px`,
            height: '80px'
          }} data-id="element-652">
                <img src={brand.logo} alt={brand.name} className="max-w-full max-h-full object-contain grayscale opacity-55 hover:grayscale-0 hover:opacity-100 transition-all duration-300" data-id="element-653" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}